import React from 'react';
import { Link } from 'react-router';
import OpenFileLink from '../../../../common/components/data-display/OpenFileLink';
import { getFileUrl } from '../../../../common/utils/helpers';

export const getInvestorGeneralContractFileUrl = (contract, token) =>
  contract && contract.fileId
    ? getFileUrl(contract.fileId, token)
    : null;

export const canSignInvestorGeneralContract = (contract, token) =>
  !!getInvestorGeneralContractFileUrl(contract, token);

export const InvestorGeneralContractAction = ({
  contract,
  token,
  t,
  SignContractComponent,
}) => {
  const fileUrl = getInvestorGeneralContractFileUrl(contract, token);

  return (
    <span>
      <span>
        {t('Vaša identita bola úspešne overená. Pre využívanie našich služieb prosím jednorazovo potvrďte Investorskú rámcovú zmluvu.')}
      </span>
      {' '}
      {fileUrl ? (
        <OpenFileLink href={fileUrl}>
          {t('Prečítať Investorskú rámcovú zmluvu')}
        </OpenFileLink>
      ) : (
        <span>{t('Dokument zatiaľ nie je dostupný')}</span>
      )}
      {' '}
      {fileUrl && SignContractComponent && (
        <SignContractComponent>
          <Link>{t('Potvrdiť Investorskú rámcovú zmluvu')}</Link>
        </SignContractComponent>
      )}
    </span>
  );
};



// WEBPACK FOOTER //
// ./src/features/dashboard/components/registration-action-alert/investorGeneralContractAction.js